/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useCallback, useImperativeHandle, useState, useEffect } from 'react';
import { TableProps, Table as AntdTable, Spin, Pagination } from 'antd';
import { delay } from '../../utils';

type Props = {
  columns: TableProps['columns'][];
  loadData: (params: {
    page: number;
    limit: number;
    query?: string;
    source: string;
  }) => Promise<any>;
  query?: string;
  filter?: any;
  onCallbackData?: (data: any) => void;
} & TableProps;

export interface DataType {
  key: string;
  name: string;
}

export interface TableRef {
  reload: () => void;
}

const Table = forwardRef<TableRef, Props>(
  ({ columns: _columns, loadData: _loadData, query, filter, onCallbackData, ...rest }, ref) => {
    const [columns, setColumns] = useState<TableProps['columns'][]>();
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState({
      current: 1,
      total: 0,
      limit: 10,
    });

    const onShowSizeChange = (current: number, pageSize: number) => {
      setPage((e) => {
        return {
          ...e,
          current: current,
          limit: pageSize,
        };
      });
    };

    const fetchData = useCallback(
      async (page: { current: number; limit: number }) => {
        try {
          setLoading(true);

          const res = await _loadData({
            ...filter,
            page: page.current,
            limit: page?.limit,
            query,
          });
          setData(res.rows);
          setPage((e) => {
            return {
              ...e,
              total: res.count,
            };
          });
          onCallbackData?.(res);
          await delay(300);
          setLoading(false);
        } catch {
          setLoading(false);
        }
      },
      [_loadData, query, filter]
    );

    useEffect(() => {
      // query эсвэл filter өөрчлөгдвөл page-г 1 болгоно
      setPage((prev) => ({
        ...prev,
        current: 1,
      }));
    }, [query, filter]);

    useImperativeHandle(ref, () => ({
      reload: () => {
        fetchData(page);
      },
    }));

    useEffect(() => {
      fetchData(page);
      console.log('page =>', page);
    }, [query, page.current, page.limit, filter]);

    useEffect(() => {
      setColumns(_columns);
    }, [_columns]);

    return (
      <>
        <Spin tip="Уншиж байна" size="small" spinning={loading}>
          <div className=" overflow-y-auto">
            <AntdTable columns={columns as any} dataSource={data} {...rest} pagination={false} />
          </div>

          <div className="pt-5 flex flex-row justify-end">
            <Pagination
              onChange={(page, pageSize) => onShowSizeChange(page, pageSize)}
              defaultCurrent={page.current}
              total={page.total}
              current={page.current}
            />
          </div>
        </Spin>
      </>
    );
  }
);

Table.displayName = 'Table';

export { Table };
